import { useMutation, useQuery } from "@tanstack/react-query";
import PurchaserClient from "../PurchaserClient";
import { queryClient } from "./client";
import type { UpdateRequisitionConfig } from "../Purchaser/RequisitionSettings";

export const QueryOptions = {
    RequisitionSettings: () => ({
        queryKey: ["requisitionSettings"],
        queryFn: () => PurchaserClient.getRequisitionSettings(),
    }),
};

export function useRequisitionSettings() {
    return useQuery(QueryOptions.RequisitionSettings());
}

export function invalidateRequisitionSettingsQueries() {
    queryClient.invalidateQueries({ queryKey: ["requisitionSettings"] });
}

export function useUpdateRequisitionSettings() {
    return useMutation({
        mutationFn: (data: UpdateRequisitionConfig) => PurchaserClient.updateRequisitionSettings(data),
        onSuccess: () => {
            invalidateRequisitionSettingsQueries();
        },
    });
}
